
import React, { useEffect, useState } from "react";
import axios from "axios";

const BASE_URL = "https://ecom.cyberathon.com";

function AboutWhyUS2() {
  const [whyUs, setWhyUs] = useState(null);

  useEffect(() => {
    const fetchWhyUs = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/index.php/Hijama/list_why_us`
        );

        if (res.data.status === "true") {
          // Sirf FIRST INDEX ka data show karega
          setWhyUs(res.data.data[0]);
        }
      } catch (error) {
        console.error("Error fetching WhyUs:", error);
      }
    };

    fetchWhyUs();
  }, []);

  if (!whyUs) {
    return <h3 className="text-center py-5">Loading...</h3>;
  }

  return (
    <>
      <div className="container-fluid bg-light px-md-5 px-5">
        <div className="col-12 col-md-2 pt-5">
          <h4 className="text-dark fs-2">
            <b>Why Us</b>
          </h4>
        </div>

        <div className="row">
          <div className="col-12 col-md-6 pt-5 ps-md-5">
            <h1>
              {whyUs.heading} <br />
            </h1>

            <div>
              {[1, 2, 3].map((num) => (
                <div className="row my-5 " key={num}>
                  <div className="col-3">
                    <div className="icon-box rounded-4 bg-col d-flex align-items-center justify-content-center m-0 ">
                      <i className="bi bi-hospital text-light fs-4"></i>
                    </div>
                  </div>
                  <div className="col-9">
                    <h3>{whyUs[`sub_heading${num}`]}</h3>
                    <p>{whyUs[`description${num}`]}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="col-12 col-md-6 pt-5 d-flex justify-content-md-end justify-content-center">
            <img
              src={`${BASE_URL}/${whyUs.image}`}
              alt="WhyUs"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutWhyUS2;
